<template>
  <div class="content" @touchmove.prevent>
    <Header :title="title" @toBack="toBack"></Header>
    <div
      :class="{
        box: true,
        box1: isStep == 1,
        box2: isStep == 2,
      }"
    >
      <!-- 通过手机号注册 -->
      <div class="step1" v-if="isStep == 1">
        <div class="codeInputBox">
          <div
            class="pcodeBox"
            v-if="codeList.length > 0"
            @click="showCode = true"
          >
            <span class="font2">{{ pcode }}</span>
            <svg-btn class="icon" icon-class="icon-short-hcode"></svg-btn>
          </div>
          <FmInput
            v-model="phone"
            :class="inputClass"
            placeholder="请输入手机号"
            clearable
          ></FmInput>
        </div>
        <fm-button
          class="loginBt"
          type="primary"
          :disabled="btnOne"
          round
          size="medium"
          @click="stepOne"
          >下一步</fm-button
        >
        <div class="bottomBox">
          <svg-btn
            class="check"
            @click="check = !check"
            :icon-class="check ? 'icon-short-hyes' : 'icon-short-hno'"
          />
          <div class="text">
            新手机号将自动注册，已详读并同意<span @click="open(91)"
              >《用户服务协议》</span
            >和<span @click="open(86)">《隐私政策》</span>
          </div>
        </div>
      </div>
      <!-- 验证手机号 -->
      <div class="step2" v-if="isStep == 2">
        <div class="topInfo">
          请输入发送至
          <span>{{
            pcode + phone.slice(0, 3) + '******' + phone.slice(9, 11)
          }}</span>
          的 6 位验证码，有效期 3 分钟
        </div>
        <VerificationCode
          ref="ver"
          :isError="isError"
          :codeValue="ucode"
          @updateValue="getValue"
        >
        </VerificationCode>
        <div class="timeBox">
          <div>
            <span v-if="time === 60" @click="againGetCode(0)"
              >重新获取验证码</span
            >
            <span v-if="time < 60">{{ time }}s后重新获取</span>
          </div>
          <span v-if="time === 60 && updateGet" @click="againGetCode(2)"
            >未收到验证码？</span
          >
        </div>
        <div class="btBox">
          <fm-button
            class="loginBt"
            type="primary"
            :disabled="btnTwo"
            round
            size="medium"
            @click="stepTwo"
            >确定</fm-button
          >
        </div>
      </div>
      <!-- 设置账号/密码 -->
      <div class="step3" v-if="isStep == 3">
        <div class="font1">设置账号</div>
        <FmInput
          v-model="username"
          class="loginInput"
          placeholder="请设置Feemoo账号（6-20位数字或字母）"
          clearable
        ></FmInput>
        <div class="font2">设置密码</div>
        <FmInput
          style="margin-bottom: 12px"
          v-model="password"
          class="loginInput"
          placeholder="请设置登录密码（至少6位数字或字母）"
          type="password"
          clearable
        ></FmInput>
        <FmInput
          v-model="cpassword"
          class="loginInput"
          placeholder="请再次输入密码"
          type="password"
          clearable
        ></FmInput>
        <div class="font2" v-if="zone_switch == 1">选择区服</div>
        <el-select
          class="loginSelect"
          placeholder="请选择区服"
          v-model="zone_id"
          v-if="zone_switch == 1"
        >
          <el-option
            v-for="item in zone_config"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <span class="font3" v-if="zone_switch == 1"
          >我们将遵照账号区服当地法律提供服务，一旦确定不可更改</span
        >
        <fm-button
          class="loginBt"
          type="primary"
          :disabled="btnThree"
          :loading="loading"
          round
          size="medium"
          @click="stepThree()"
          >确定</fm-button
        >
      </div>
    </div>
    <pcodeCheck
      @touchmove.stop
      :codeList="codeList"
      :show="showCode"
      :code="pcode"
      @close="showCode = false"
      @toCheck="toCheck"
    />
    <wxLink
      :isShow="wxLinkShow"
      :agreement="true"
      title="提示"
      submitText="同意"
      cancelText="不同意"
      @submit="submitLink"
      @handleClose="wxLinkShow = false"
    />
  </div>
</template>

<script>
import Header from '@/components/NavTopLogin/index.vue'
import pcodeCheck from '@/components/pcodeCheck/index.vue'
import VerificationCode from '@/components/VerificationCode/index.vue'
import wxLink from '@/components/Dialog/wxLink.vue'
import {
  getPhonePcodeAPI,
  phoneLoginCodeAPI,
  checkPhone,
  registerAPI,
  LoginSSOAPI,
  getZoneIdConfigAPI,
} from '@/axios/login'
export default {
  name: 'phoneRegister',
  components: {
    Header,
    pcodeCheck,
    VerificationCode,
    wxLink,
  },
  data() {
    return {
      phone: '',
      pcode: '+86',
      isStep: 1,
      title: '通过手机号注册',
      showCode: false,
      ucode: '', //验证码字段
      time: 60,
      timerA: '',
      updateGet: false,
      password: '',
      cpassword: '',
      sms_type: 0,
      wxLinkShow: false,
      check: false,
      codeList: [],
      msgid: '',
      isError: false,
      fshort: '',
      username: '',
      password: '',
      cpassword: '',
      loading: false,
      zone_id: '', //区服ID
      zone_switch: 0, //区服开关
      zone_config: [], //区服list
    }
  },
  watch: {
    deviceClass() {
      if (this.deviceClass == 'pc') {
        window.location.replace(`${this.$glb.feemooUrl}/login?path=drive`)
      }
    },
    ucode() {
      if (this.ucode.length < 6) {
        this.isError = false
      }
    },
  },
  mounted() {
    if (this.deviceClass == 'pc') {
      window.location.replace(`${this.$glb.feemooUrl}/login?path=drive`)
    }
    this.fshort = sessionStorage.getItem('shortFshort') || ''
    this.getZoneIdConfig()
    this.getPhonePcode()
  },
  computed: {
    deviceClass() {
      return this.$store.getters['device/deviceClass']
    },
    inputClass() {
      // 逻辑单独抽离，更易读
      if (this.codeList.length > 0) {
        return `codeInput${this.pcode.length - 1}`
      } else {
        return 'loginInput'
      }
    },
    btnOne() {
      if (this.pcode == '+86' && this.phone.length == 11) {
        return false
      } else if (this.pcode != '+86' && this.phone) {
        return false
      }
      return true
    },
    btnTwo() {
      if (this.ucode.length == 6) {
        return false
      }
      return true
    },
    btnThree() {
      if (
        this.username.trim().length >= 6 &&
        this.password.trim().length >= 6 &&
        this.cpassword.trim().length >= 6
      ) {
        return false
      }
      return true
    },
  },
  methods: {
    getZoneIdConfig() {
      getZoneIdConfigAPI()
        .then(res => {
          if (res.status == 1) {
            this.zone_switch = res.data.zone_switch
            this.zone_config = res.data.zone_config
            const selectedZone = this.zone_config.find(
              item => item.is_select == 1
            )
            // 如果找到则赋值id，否则可以设置默认值或处理未找到的情况
            this.zone_id = selectedZone ? selectedZone.id : '' // 或其他默认值
          }
        })
        .catch(err => {})
    },
    //获取区号
    getPhonePcode() {
      // type: 1是注册的区号 2是登录 3是忘记密码的区号 4是绑定手机号
      getPhonePcodeAPI({ type: 1 })
        .then(res => {
          if (res.status == 1) {
            this.codeList = res.data.list
          }
        })
        .catch(err => {})
    },
    stepOne: _.debounce(
      function (captcha_verify, validate = {}) {
        if (this.btnOne) {
          return
        }
        if (!this.check) {
          this.wxLinkShow = true
          return
        }
        var reg_tel =
          /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
        if (this.pcode == '+86' && !reg_tel.test(this.phone)) {
          this.$htoast('请正确输入手机号')
          return
        }
        return new Promise(resolve => {
          if (validate == 'close') {
            return
          }
          this.clearOp()
          let data = {
            pcode: this.pcode,
            phone: this.phone,
            code_type: 0, //验证码类型：0-短信登录注册 1-短信找回密码 2-修改手机号
            captcha_verify: captcha_verify || '',
            lot_number: validate?.lot_number || '',
            captcha_output: validate?.captcha_output || '',
            pass_token: validate?.pass_token || '',
            gen_time: validate?.gen_time || '',
            sms_type: this.sms_type, //0是获取验证码，2是重新验证码
          }
          phoneLoginCodeAPI(data)
            .then(res => {
              if (res.status == 1) {
                resolve({
                  result: true,
                  validate: true,
                })
                this.msgid = res.data.msgid
                this.isStep = 2
                this.title = '验证手机号'
                if (this.time === 60) {
                  this.timerA = setInterval(() => {
                    this.minute()
                  }, 1000)
                }
                this.ucode = ''
                this.$nextTick(() =>{
                  this.$refs.ver?.reset()
                })
                this.$htoast(res.msg)
              } else if (res.status == 90001) {
                resolve({
                  result: false,
                  validate: false,
                })
                this.$htoast(res.msg)
                this.$AliCode.handleOpen(this.stepOne)
              } else if (res.status == 90002) {
                this.$utils.initgt4(
                  '5b0562a75492b420626b745b229e83a4',
                  this.stepOne
                )
              } else {
                resolve({
                  result: true,
                  validate: true,
                })
                this.$htoast(res.msg)
              }
            })
            .catch(err => {})
        })
      },
      500,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    //清除输入验证码数据
    clearOp() {
      this.time = 60
      this.timerA && clearInterval(this.timerA)
    },
    stepTwo: _.debounce(
      function () {
        if (this.btnTwo) {
          return
        }
        let data = {
          pcode: this.pcode,
          phone: this.phone,
          msgid: this.msgid,
          ucode: this.ucode,
        }
        checkPhone(data).then(res => {
          if (res.status == 1) {
            //进入设置账号密码
            this.clearUP()
            this.isStep = 3
            this.title = '设置账号/密码'
          } else if (res.status == 1014) {
            //已经注册过的手机号走注册
            this.stepThree('have')
          } else {
            this.isError = true
            this.$htoast(res.msg)
          }
        })
      },
      500,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    stepThree: _.debounce(
      function (row) {
        if ((!row && this.btnThree) || this.loading) {
          return
        }
        let length = this.username.trim().length
        if ((length < 6 || length > 20) && !row) {
          this.$htoast('Feemoo账号仅支持6-20位数字或字母，请修改')
          return
        }
        if (this.password !== this.cpassword && !row) {
          this.$htoast('密码不一致，请重试')
          return
        }
        this.loading = true
        let data = {
          username: this.username,
          password: this.password,
          cpassword: this.cpassword,
          phone: this.phone,
          ucode: this.ucode,
          msgid: this.msgid,
          pcode: this.pcode,
          rcode: this.fshort,
          zone_id: this.zone_id,
        }
        registerAPI(data)
          .then(res => {
            if (res.status == 1) {
              LoginSSOAPI({ token: res.data.sso[0].token }).then(res => {
                if (res.status == 1) {
                  localStorage.setItem('shortToken', res.data.authtoken)
                }
              })
              setTimeout(() => {
                this.toComplete()
              }, 600)
            } else {
              this.loading = false
              this.$htoast(res.msg)
            }
          })
          .catch(err => {
            this.loading = false
          })
      },
      500,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    toComplete() {
      let fshort = sessionStorage.getItem('shortFshort')
      this.loading = false
      if (fshort) {
        this.$router.replace({ path: '/d/' + fshort })
      } else {
        this.$router.replace({ path: '/' })
      }
    },
    submitLink() {
      this.wxLinkShow = false
      this.check = true
      this.stepOne()
    },
    minute: function () {
      this.time = this.time - 1
      if (this.time == 0) {
        this.time = 60
        this.updateGet = true
        clearInterval(this.timerA)
      }
    },
    //验证码输入回调
    getValue(newValue) {
      this.ucode = newValue
      if (this.ucode.length == 6) {
        this.stepTwo()
      }
    },
    againGetCode(row) {
      this.sms_type = row
      this.stepOne()
    },
    //清除账号密码
    clearUP() {
      this.username = ''
      this.password = ''
      this.cpassword = ''
      const selectedZone = this.zone_config.find(item => item.is_select == 1)
      // 如果找到则赋值id，否则可以设置默认值或处理未找到的情况
      this.zone_id = selectedZone ? selectedZone.id : '' // 或其他默认值
    },
    toCheck(num) {
      this.pcode = num
      this.showCode = false
    },
    toBack() {
      if (this.isStep == 1) {
        this.$router.replace({ path: '/login', query: { isType: 2 } })
      } else if (this.isStep == 2) {
        this.title = '通过手机号注册'
        this.isStep = 1
      } else if (this.isStep == 3) {
        this.title = '验证手机号'
        this.isStep = 2
      }
    },
    open(num) {
      // window.location.href = this.$glb.shareUrl + '/agreement/?code=' + num
      // window.open(url, '_href')
      if (this.detectBrowser()) {
        let url = this.$glb.shareUrl + '/agreement/?code=' + num
        //曲线救国，如果不设置窗口名，浏览器会限制只能开一个窗口
        const windowName = 'phoneRegister' + new Date().getTime();
        window.open(url, windowName);
        window.open(url, '_href')
      } else {
        window.location.href = this.$glb.shareUrl + '/agreement/?code=' + num
      }
    },
    // 兼容主流浏览器 safari Chrome Firefox
    detectBrowser() {
      const userAgent = navigator.userAgent.toLowerCase();
      const vendor = navigator.vendor ? navigator.vendor.toLowerCase() : '';
      
      // 检测Safari
      const isSafari =
        vendor.includes('apple') &&
        userAgent.includes('safari') &&
        !userAgent.includes('chrome') &&
        !userAgent.includes('crios') &&
        !userAgent.includes('fxios');
      
      // 检测Chrome（包括移动版Chrome）
      const isChrome =
        (userAgent.includes('chrome') || userAgent.includes('crios')) &&
        // 排除Edge浏览器（因为Edge的UA也可能包含chrome）
        !userAgent.includes('edg') &&
        !userAgent.includes('edge');
      
      // 检测Firefox（包括移动版Firefox）
      const isFirefox = 
        userAgent.includes('firefox') || 
        userAgent.includes('fxios');
      
      // 如果是其中任意一种浏览器则返回true
      return isSafari || isChrome || isFirefox;
    }
  },
}
</script>

<style lang="scss" scoped>
.content {
  display: flex;
  flex-direction: column;
  background: #ffffff;
  overflow: auto;
  height: 100%;
  overflow-x: hidden;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
  &::-webkit-scrollbar-thumb {
    display: none;
  }
  &::-webkit-scrollbar-track {
    display: none;
  }
  .box {
    height: 100%;
    padding: 40px 34px 0 34px;
    .step1 {
      display: flex;
      flex-direction: column;
      .loginBt {
        width: 100%;
        height: 48px;
        border-radius: 48px;
        margin-top: 24px;
        span {
          font-weight: 500;
          font-size: 14px;
          color: #ffffff;
          line-height: 20px;
        }
      }
      .bottomBox {
        display: flex;
        align-items: flex-start;
        margin-top: 20px;
        .check {
          width: 14px;
          height: 14px;
          margin-right: 2px;
          margin-top: 1px;
        }
        .text {
          font-weight: 400;
          font-size: 12px;
          color: #bdbdbe;
          line-height: 16px;
          span {
            color: #2c2c2c;
          }
        }
      }
    }
    .step2 {
      .topInfo {
        font-weight: 400;
        font-size: 14px;
        color: #8a8b92;
        line-height: 20px;
        text-align: left;
        margin-bottom: 32px;
        width: 100%;
        span {
          color: #2c2c2c !important;
        }
      }
      .timeBox {
        margin-top: 24px;
        font-weight: 400;
        font-size: 14px;
        color: #f67942;
        line-height: 20px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .btBox {
        margin-top: 32px;
        padding: 0 18px;
        .loginBt {
          width: 100%;
          height: 48px;
          border-radius: 48px;
          span {
            font-weight: 500;
            font-size: 14px;
            color: #ffffff;
            line-height: 20px;
          }
        }
      }
    }
    .step3 {
      display: flex;
      flex-direction: column;
      .font1 {
        font-weight: 400;
        font-size: 14px;
        color: #2c2c2c;
        line-height: 20px;
        margin-bottom: 12px;
      }
      .font2 {
        font-weight: 400;
        font-size: 14px;
        color: #2c2c2c;
        line-height: 20px;
        margin-bottom: 12px;
        margin-top: 36px;
      }
      .font3 {
        font-weight: 400;
        font-size: 11px;
        color: #bdbdbe;
        line-height: 16px;
        margin-top: 4px;
        margin-left: 6px;
      }
      .loginBt {
        width: 100%;
        height: 48px;
        border-radius: 48px;
        margin-top: 24px;
        span {
          font-weight: 500;
          font-size: 14px;
          color: #ffffff;
          line-height: 20px;
        }
      }
    }
  }
  .box1 {
    padding-top: 64px;
  }
  .box2 {
    padding-right: 16px;
    padding-left: 16px;
  }
}
</style>
